import React from 'react'
import MuiPagination from '@mui/material/Pagination'
import styled from 'styled-components'

import useScreenSize from 'hooks/useScreenSize'

import { color } from 'styles/colors'

type props = {
  page: number
  pageCount: number
  size?: 'small' | 'medium' | 'large'
  onPageChange: (number) => void
  className?: string
}

const StickyPagination = ({ page = 1, pageCount = 0, size = 'medium', onPageChange, className = '' }: props) => {
  const screenSize = useScreenSize()

  return (
    <S.Container className={className}>
      <S.GreyBackground>
        <MuiPagination
          size={size}
          count={pageCount}
          onChange={(_event, page) => onPageChange(page)}
          page={page}
          color="primary"
          siblingCount={screenSize === 'medium' || screenSize === 'small' ? 0 : undefined}
          boundaryCount={screenSize === 'medium' || screenSize === 'small' ? 1 : undefined}
        />
      </S.GreyBackground>
    </S.Container>
  )
}

export default StickyPagination

const S = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15px;
    position: sticky;
    bottom: 20px;
    white-space: nowrap;
  `,
  GreyBackground: styled.div`
    margin-right: 15px;
    padding: 0 5px;
    border-radius: 20px;
    background-color: ${color('paginationBackground')};
  `
}
